/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icon-door': {
    width: 15,
    height: 25,
    viewBox: '0 0 15 25',
    data: '<g _fill="#203F6A" fill-rule="nonzero" _stroke="#203F6A" stroke-width=".4"><path pid="0" d="M.645 1.46c0-.221.098-.42.252-.559a1 1 0 01.748-.335h11.453c.754 0 1.365.609 1.365 1.357v16.135c0 .746-.611 1.355-1.365 1.355h-3.86v3.673a.756.756 0 01-1.156.64l-7.077-4.345a.744.744 0 01-.353-.54H.645V1.462zm1.152.702v16.362l6.29 3.862V6.026l-6.29-3.864zm11.3-.454H3.246l5.634 3.46c.225.135.36.376.36.638V18.27h3.859a.213.213 0 00.214-.214V1.923a.213.213 0 00-.214-.215z"/><path pid="1" d="M6.463 12.203c.402 0 .728.325.728.727v2.182a.727.727 0 01-1.455 0V12.93c0-.402.326-.727.727-.727z"/></g>'
  }
})
